module.exports = __webpack_public_path__ + "img/78_39.98de726c.png";